import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  text,
  paragraph,
} from '@groovehq/internal-design-system/lib/styles/elements'

import { string, bool } from 'prop-types'
import { selectCurrentAgentById } from 'ducks/agents/selectors'
import { doArchiveAgent } from 'ducks/agents/operations'
import EntityDeleteDrawer from '../EntityDelete'

const AgentArchiveDrawer = props => {
  const {
    title,
    open,
    drawerResourceId: agentId,
    onClose,
    onExit,
    onRemove,
  } = props

  const dispatch = useDispatch()

  const agent = useSelector(state => selectCurrentAgentById(state, agentId))

  const handleOnRemove = useCallback(
    () => {
      dispatch(doArchiveAgent(agentId))
      if (onRemove) onRemove(agentId)
    },
    [dispatch, agentId, onRemove]
  )

  if (!agent) return null

  const { email } = agent

  return (
    <EntityDeleteDrawer
      {...props}
      onRemove={handleOnRemove}
      onClose={onExit}
      onCancel={onClose}
      title={title}
      deleteBtnText="Archive"
      tertiaryBtnText="Cancel"
      open={open}
    >
      <div className="grui mt-7">
        <div css={text.styles.textNormal}>
          <p css={[paragraph.styles.preflight, text.styles.fontMedium]}>
            You are about to archive {email}.
          </p>
          <br />
          <p css={paragraph.styles.preflight}>
            The {app.t('agent')} will no longer be able to access Groove and
            will no longer be available to be assigned to conversations.
          </p>
        </div>
      </div>
    </EntityDeleteDrawer>
  )
}

AgentArchiveDrawer.propTypes = {
  title: string,
  open: bool.isRequired,
  drawerResourceId: string,
}

AgentArchiveDrawer.defaultProps = {
  title: `Archive ${app.t('agent')}`,
  drawerResourceId: '',
  queryId: null,
}

export default AgentArchiveDrawer
